import TableRepository from '@src/repositories/TableRepository';

class TableService {
  constructor() {
    this.tableRepository = new TableRepository();
  }

  async createTable({ data, orgId, divId = null, boardId }) {
    return this.tableRepository.create({ data, orgId, divId, boardId });
  }

  async updateTable({ data, orgId, divId = null, boardId, tableId }) {
    return this.tableRepository.update({ data, orgId, divId, boardId, tableId });
  }

  async deleteTable({ orgId, divId = null, boardId, tableId }) {
    return this.tableRepository.delete({ orgId, divId, boardId, tableId });
  }

  async getTable({ orgId, divId = null, boardId, tableId }) {
    return this.tableRepository.get({ orgId, divId, boardId, tableId });
  }
}

export default TableService;
